import { MdCancel } from "react-icons/md";
import { FaEye } from "react-icons/fa";

export const ChequesSectionContent = ({ section, records, handleViewCheque }) => (
  <div className="adp-table-wrap">
    <table className="adp-files-event-table">
      <thead>
        <tr>
          {section.columns.map((column) => (
            <th key={column}>{column}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {records.map((record, index) => (
          <tr key={record.id || `cheque-${index}`}>
            <td>{record.vinId}</td>
            <td>{record.amount}</td>
            <td>{record.payableTo}</td>
            <td>{record.status}</td>
            <td>{record.date}</td>
            <td>
              {record.s3Key && record.s3Key !== "NA" ? (
                <button
                  className="adp-cheque-view-btn"
                  type="button"
                  title="View Cheque"
                  onClick={() => handleViewCheque(record)}
                >
                  <FaEye />
                </button>
              ) : (
                "NA"
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export const ChequePreviewModal = ({ isOpen, chequePdfUrl, viewChequeRequestId, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="adp-cheque-overlay">
      <div className="adp-cheque-modal">
        <div className="adp-cheque-modal-header">
          <span>Cheque : ({viewChequeRequestId})</span>
          <button
            className="adp-cheque-modal-close"
            type="button"
            onClick={onClose}
            aria-label="Close cheque preview"
          >
            <MdCancel size={16} />
          </button>
        </div>
        <div className="adp-cheque-modal-body">
          <iframe src={chequePdfUrl} title="Cheque PDF" className="adp-cheque-pdf-viewer" />
        </div>
      </div>
    </div>
  );
};

const ChequesModal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="adp-section-modal-overlay" >
      <div className="adp-section-modal" >
        <div className="adp-section-modal-header">
          <span>Cheques</span>
          <button className="adp-section-modal-close" type="button" onClick={onClose} aria-label="Close Cheques">
            <MdCancel size={25} />
          </button>
        </div>
        <div className="adp-section-modal-body">
          {children}
        </div>
      </div>
    </div>
  );
};

export default ChequesModal;
